/**
 * Package that wraps the functionality of the Ajv JSON Schema validator to
 * meet FEC specific use cases.
 *
 * Compiled into dist/index.js
 * Tested with spec/index-spec.js
 */
/**
 * Takes a schema in JSON format and data object to be validated and returns an
 * array of ValidationError objects for all validation errors found by Ajv.
 *
 * @param {object} schema
 * @param {object} data
 * @param {string[]} fieldsToValidate
 * @returns {ValidationError[]} Modified version of Ajv output, empty array if no errors found
 */
export async function validate(schema, data, fieldsToValidate = []) {
    var _a;
    const schemaName = schemaToKey(schema);
    if (!schemaName) {
        return Promise.reject(new Error("Failed to retrieve schemaName"));
    }
    const module = await import(`../dist/${schemaName}.validator.js`);
    const validator = module[schemaName];
    const isValid = validator(data);
    const errors = [];
    if (!isValid && !!((_a = validator.errors) === null || _a === void 0 ? void 0 : _a.length)) {
        validator.errors.forEach((error) => {
            const parsedError = parseError(error);
            if (!fieldsToValidate.length ||
                fieldsToValidate.includes(parsedError.path)) {
                errors.push(parsedError);
            }
        });
    }
    return errors;
}
/**
 * Format error message from Ajv into our ValidationError interface
 * @param {ErrorObject} error - Ajv ErrorObject interface
 * @returns {ValidationError}
 */
function parseError(error) {
    let path = error.instancePath.substring(1);
    if (error.keyword == "required") {
        path = error.params.missingProperty;
    }
    return {
        path: path,
        keyword: error.keyword,
        params: error.params,
        message: !!error.message ? error.message : null,
    };
}
function schemaToKey(schema) {
    if (schema && schema.$id) {
        const startIndex = schema.$id.lastIndexOf("/");
        const endIndex = schema.$id.indexOf(".json");
        return schema.$id.substring(startIndex + 1, endIndex);
    }
}
